module.exports = __webpack_public_path__ + "img/alert_icon.7f93fda5.svg";